import { User } from "@/modules/reporting/domain/User";
import { sync_command_dispatcher } from "@/api/client";
import { UserRepoInterface } from "../application/SaveUserInvoiceNotificationCommand";

export class UserRepo implements UserRepoInterface {
  private dispatcher: any;

  constructor(dispatcher = sync_command_dispatcher) {
    this.dispatcher = dispatcher;
  }

  async save(user: User): Promise<void> {
    await this.dispatcher.dispatch("save_user_invoice_notification", {
      user_id: user.id,
      enable_invoice_notifications: user.enable_invoice_notifications,
    });
  }
}

export class MemoryUserRepo implements UserRepoInterface {
  public saved: any[] = [];

  async save(user: User): Promise<void> {
    this.saved.push({
      cmd_name: "save_user_invoice_notification",
      user_id: user.id,
      enable_invoice_notifications: user.enable_invoice_notifications,
    });
  }
}